var _defs, _path, _path2, _path3, _circle, _rect, _circle2, _line, _rect2, _circle3, _line2, _rect3, _circle4, _line3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnPremisesLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-15 0 130 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#38bdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563eb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8 38 L 50 12 L 92 38",
    fill: "none",
    stroke: "url(#blueGrad)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 18 32 V 75",
    fill: "none",
    stroke: "url(#blueGrad)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 82 32 V 75",
    fill: "none",
    stroke: "url(#blueGrad)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 24,
    r: 3,
    fill: "#38bdf8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 32,
    width: 44,
    height: 11,
    rx: 2.5,
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 37.5,
    r: 2,
    fill: "#38bdf8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 37.5,
    x2: 65,
    y2: 37.5,
    stroke: "#0ea5e9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 48,
    width: 44,
    height: 11,
    rx: 2.5,
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 53.5,
    r: 2,
    fill: "#38bdf8"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 53.5,
    x2: 65,
    y2: 53.5,
    stroke: "#0ea5e9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 64,
    width: 44,
    height: 11,
    rx: 2.5,
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 69.5,
    r: 2,
    fill: "#38bdf8"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 69.5,
    x2: 65,
    y2: 69.5,
    stroke: "#0ea5e9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 95,
    fontFamily: "'Inter', sans-serif",
    fontSize: 13,
    fontWeight: 800,
    fill: "#38bdf8",
    textAnchor: "middle",
    letterSpacing: 1
  }, "ON-PREMISE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnPremisesLogo);
export default __webpack_public_path__ + "static/media/on-premises-logo.c1739dcc334c5ca49743db9306b74967.svg";
export { ForwardRef as ReactComponent };